module.exports = __webpack_public_path__ + "img/6.d3c1ba0d.png";